import { LotMarche } from './LotMarche';
import { TypeResultatAttribution } from './TypeResultatAttribution';

export class Attribution {

	public lotMarche: LotMarche[];

	public resultat: TypeResultatAttribution;

	constructor() {
		this.lotMarche = [];
		this.resultat = new TypeResultatAttribution();
	}
}
